import { render, staticRenderFns } from "./VoucherCard.vue?vue&type=template&id=5f8104cc&scoped=true&"
import script from "./VoucherCard.vue?vue&type=script&lang=js&"
export * from "./VoucherCard.vue?vue&type=script&lang=js&"
import style0 from "./VoucherCard.vue?vue&type=style&index=0&id=5f8104cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8104cc",
  null
  
)

export default component.exports